// Shared IC-agreement onboarding email + signing link — Sep 9, 2026.
// Extracted from OnboardICModal so the Team Roster board's add-member flow and
// the home-page Onboard IC modal send the identical email: one copy, no drift.
import { supabase } from "./supabase";

export function icSigningLink(token: string): string {
  return `${window.location.origin}/ic-sign?token=${encodeURIComponent(token)}`;
}

export function icSigningEmailHtml(fullName: string, signingLink: string): string {
  const first = fullName.trim().split(" ")[0] || fullName.trim();
  return `<div style="font-family: -apple-system, sans-serif; max-width: 560px; margin: 0 auto;">
    <div style="background: #2a2e30; padding: 20px 24px; border-radius: 12px 12px 0 0;">
      <h1 style="color: #f46530; font-size: 20px; margin: 0;">BARDIN ROOFING</h1>
      <p style="color: #ff9e7a; font-size: 13px; margin: 4px 0 0;">Independent Contractor Agreement</p>
    </div>
    <div style="background: #ffffff; padding: 24px; border: 1px solid #e0e6eb; border-top: none; border-radius: 0 0 12px 12px;">
      <p style="font-size: 15px; color: #2a2e30;">Hi ${first},</p>
      <p style="font-size: 14px; color: #3a3f44; line-height: 1.6;">
        Welcome to the Bardin Roofing team! Before you get started, please review and sign your Independent Contractor Agreement.
      </p>
      <div style="text-align: center; margin: 24px 0;">
        <a href="${signingLink}" style="display: inline-block; background: #f46530; color: #ffffff; font-weight: 700; font-size: 15px; padding: 14px 32px; border-radius: 10px; text-decoration: none;">
          Review &amp; Sign Agreement
        </a>
      </div>
      <p style="font-size: 12px; color: #8a9199; line-height: 1.5;">
        This link is unique to you. After signing, you'll be able to log in to the Bardin Roofing portal at app.bardinroofing.com.
      </p>
      <hr style="border: none; border-top: 1px solid #e0e6eb; margin: 20px 0;" />
      <p style="font-size: 11px; color: #aab0b7; text-align: center;">
        Peach Duck Contracting Company, S Corp. d/b/a Bardin Roofing<br />
        225 Reformation Pkwy, Suite 200, Canton, GA 30114 | (470) 823-8816
      </p>
    </div>
  </div>`;
}

// Throws on failure (supabase.functions.invoke RESOLVES with {error} — it never
// rejects, so the error must be checked here). Both callers treat a failed
// email as non-blocking: the signing link is shown so it can be shared by hand.
export async function sendIcSigningEmail(to: string, fullName: string, signingLink: string): Promise<void> {
  const { error } = await supabase.functions.invoke("send-email", {
    body: {
      to,
      subject: "Bardin Roofing — Sign Your Independent Contractor Agreement",
      html: icSigningEmailHtml(fullName, signingLink),
    },
  });
  if (error) throw error;
}
